<template>
  <ValidationObserver ref="formAgency" novalidate>
    <form novalidate @submit.prevent="save">
      <div class="ml-2 mr-2 mt-n3">
        <CustomCollapse id="addAgency" class="mt-2">
          <CustomCollapseItem
            parent-id="addAgency"
            title="Añadir Agencia"
            :selected="true"
            :expanded="true"
            class="badge-modal-custom"
          >
            <div class="row ml-2">
              <div class="col-md-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomDropDown
                    id="ddlAgency"
                    v-model="info.selectedAgency"
                    label="Agencia"
                    placeholder="Seleccione"
                    fieldkey="id"
                    fieldname="name"
                    :options="agencyList"
                    :error="errors[0]"
                    custom-error-msg="Campo requerido."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-3">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomInput
                    v-model="info.recordNumber"
                    label="Número:"
                    placeholder="Número de registro"
                    :error="errors[0]"
                    custom-error-msg="Campo requerido."
                  />
                </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomTextArea
                    id="txtAgencyServiceDescription"
                    v-model="info.serviceDescription"
                    label="Servicio(s): "
                    :maxlength="500"
                    :row="5"
                    :error="errors[0]"
                    custom-error-msg="Campo requerido."
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mr-n2">
              <div class="col text-right">
                <ActionButton
                  id="btnAgencyCancel"
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger m-2"
                  @click="cancel"
                >
                  Cancelar
                </ActionButton>
                <ActionButton
                  v-if="!isEditMode"
                  id="btnAgencyAddNew"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                >
                  Añadir
                </ActionButton>
                <ActionButton
                  v-if="isEditMode"
                  id="btnAgencySaveExisting"
                  i="fas fa-save"
                  variant="success m-2 pl-4 pr-4"
                  type="submit"
                >
                  Guardar
                </ActionButton>
              </div>
            </div>
          </CustomCollapseItem>
        </CustomCollapse>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  CustomDropDown,
  CustomInput,
  ActionButton,
  CustomTextArea,
} from '@/components/common';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

const GET_AGENCY_LIST = 'api/studentregistry/getagencylist/';
const DEFAULT_AGENCY_ID_TO_EDIT = 0;
export default {
  name: 'OtherAgencyServiceAdd',
  data() {
    return {
      info: {
        selectedAgency: null,
        recordNumber: '',
        serviceDescription: '',
      },
      agencyList: [],
    };
  },
  computed: {
    isEditMode() {
      return this.agency ? true : false;
    },
  },
  props: {
    agency: {
      type: Object,
      default: () => null,
    },
    studentSieId: {
      type: Number,
      default: () => 0,
    },
  },
  methods: {
    getAgencyList(agencyId) {
      return new Promise(async (resolve, reject) => {
        if (this.studentSieId > 0) {
          const { data: agencyList } = await this.$ApiGet(
            `${GET_AGENCY_LIST}${this.studentSieId}/${agencyId}`
          );
          if (agencyList) {
            resolve(agencyList);
          }
        } else {
          reject({});
        }
      });
    },
    async loadAgencyInfo(item) {
      const _agencyList = await this.getAgencyList(
        item ? item.agencyId : DEFAULT_AGENCY_ID_TO_EDIT
      );
      this.agencyList = _agencyList;
      if (this.isEditMode) {
        const _info = {
          ...this.agency,
          selectedAgency: item
            ? _agencyList.filter(
                (item) => item.id === this.agency.agencyId
              )[0] || null
            : null,
        };
        this.info = _info;
      }
    },
    cancel() {
      this.$emit('on-cancel');
    },
    async save() {
      const isValid = await this.$refs.formAgency.validate();
      this.$emit(
        'on-save',
        isValid
          ? {
              ...this.info,
              oldAgencyId: this.info.agencyId,
              agencyId: this.info.selectedAgency.id,
            }
          : null,
        this.isEditMode
      );
    },
  },
  async mounted() {
    await this.loadAgencyInfo(this.agency);
  },
  components: {
    ActionButton,
    CustomDropDown,
    CustomInput,
    CustomCollapse,
    CustomCollapseItem,
    ValidationObserver,
    ValidationProvider,
    CustomTextArea,
  },
};
</script>

<style scoped>
.badge-modal-custom >>> .tag-badge-title {
  font-size: 20px;
}

.badge-modal-custom >>> .tag-badge-pei {
  margin-left: -10px;
}
.danger-text {
  color: #e85c5c;
}
</style>
